export const validationTranslationsNL = {
    required: 'Verplicht veld',
    invalidNumber: 'Veld moet een geldig getal zijn',
    invalidDate: 'Veld moet een geldige datum zijn',
    negativeNumber: 'Veld moet positief zijn',
};
